export const formatLastCommunication = (dateString: string | null | undefined): string => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return dateString;
  }
};

export const formatFirstCommunication = (dateString: string | null | undefined): string => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return dateString;
  }
};

export const formatAlertTime = (alertTime: string | null | undefined): string => {
  if (!alertTime) return '';

  try {
    const date = new Date(alertTime);
    if (isNaN(date.getTime())) return alertTime;

    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return alertTime || '';
  }
};

export const getSeverityClass = (severity: string | null | undefined): string => {
  if (!severity) return 'info';

  const severityLower = severity.toLowerCase();
  switch (severityLower) {
    case 'critical':
    case 'high':
      return 'critical';
    case 'warning':
    case 'medium':
      return 'warning';
    case 'info':
    case 'low':
      return 'info';
    default:
      return 'info';
  }
};
